import React, { useState, useEffect, Fragment, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from "react-router";

import office365 from '../../../assets/images/office365.png';
import googleImage from '../../../assets/images/google.png';

import '../../../assets/css/signin.css'

import Spinner from '../../../components/Widgets/Spinner';

import axios from "axios";

const resolveAssetUrl = (path) => {
    if (!path || path === "null" || path === "undefined") return null;
    const trimmed = String(path).trim();
    if (!trimmed) return null;
    if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith("data:")) {
        return trimmed;
    }
    return (process.env.REACT_APP_SIMPLE_API_URL || "") + trimmed;
};

const AppSignin = ({ history }) => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [cloudId, setCloudId] = useState("");
    const [passcode, setPasscode] = useState("");
    const [mfa, setMfa] = useState({});
    const [subscribers, setSubscribers] = useState([]);
    const [ssoType, setSsoType] = useState('');
    const [ssoToken, setSsoToken] = useState('');
    const [accessToken, setAccessToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [googleClientId, setGoogleClientId] = useState("");
    const [microsoftClientId, setMicrosoftClientId] = useState("");
    const [microsoftTenantId, setMicrosoftTenantId] = useState("07de3ba6-e3bf-416c-8d3e-a3e6a0d1b4b9");
    const [build, setBuild] = useState('dev');
    const [signinLogo, setSigninLogo] = useState(localStorage.getItem("signin_logo"));
    const [background, setBackground] = useState(localStorage.getItem("app_signin_background"));
    const [fontColor, setFontColor] = useState(localStorage.getItem("app_signin_font_color"));

    const logoUrl = resolveAssetUrl(signinLogo);
    const backgroundUrl = resolveAssetUrl(background);

    // // Function to generate a nonce
    const generateNonce = () => {
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    };
    useEffect(() => {

        const url = new URL(window.location.href);
        const myBuild = process.env.REACT_APP_ENVIRONMENT;
        const myCloudId = url.searchParams.get("cloud_id");
        setBuild(myBuild);
        setCloudId(myCloudId);
        console.log("FRONTEND URL -->",process.env.REACT_APP_FRONTEND_URL)
        const payLoad = {
            cloud_id: myCloudId
        };
        axios.post(`${process.env.REACT_APP_ADMIN_API_URL}getsigninlogo`, payLoad)
            .then(response => {
                localStorage.setItem("signin_logo", response.data.app_signin_logo);
                localStorage.setItem("app_signin_background", response.data.app_signin_background);
                localStorage.setItem("app_signin_font_color", response.data.app_signin_font_color);
                localStorage.setItem("app_signin_button_color", response.data.app_signin_button_color);
                localStorage.setItem("app_signin_button_font_color", response.data.app_signin_button_font_color);
                setSigninLogo(response.data.app_signin_logo);
                setBackground(response.data.app_signin_background);
                setFontColor(response.data.app_signin_font_color);
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err.message);
                }

            });
    }, []);


    useEffect(() => {
        const url = new URL(window.location.href);
        const myCloudId = url.searchParams.get("cloud_id");
        setCloudId(myCloudId.replaceAll("*", ""));
        //TODO: Call an APi to get the logo against this cloud id as well as client ids of google and mirsoft
        const payload = {
            "cloud_id": myCloudId
        }
        axios.post(`${process.env.REACT_APP_ADMIN_API_URL}getClientIds`, payload)
        .then(response => {
            setGoogleClientId(response.data.google_clientid);
            setMicrosoftClientId(response.data.office365_clientid);
            //setMicrosoftTenantId(response.data.office365_tenantid);
        })
        .catch(err => {
            console.log(err);
        })
    }, []);

    useEffect(() => {
        // Get the current URL
        const currentUrl = window.location.href;

        // Check if the URL starts with 'csc:'
        if (currentUrl.startsWith('csc:')) {
            // Extract the token by removing 'csc:' prefix
            const token = currentUrl.replace('csc:', '');

            // Set the token in state
            setAccessToken(token);

            console.log("Captured Token:", token);

            // Optionally, you can send this token to the server or handle it further
        }
    }, []);

    // Handle Google sign-in by opening in an external browser
    const handleGoogleSignIn = () => {
        const baseURL = window.location.origin;
        const nonce = generateNonce(); // Generate a random nonce
        const encodedCloudId = encodeURIComponent(cloudId); // Encode cloudId to handle special characters
        const googleAuthURL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${googleClientId}&redirect_uri=${baseURL}/authCallback&response_type=id_token&scope=profile email&nonce=${nonce}&state=${cloudId+ "@google"}`;

        // Open the Google SSO page in an external browser
        //alert(googleAuthURL);
        window.location.href = googleAuthURL;

    };

    // Handle Microsoft sign-in by opening in an external browser
    const handleMicrosoftSignin = () => {
        const baseURL = window.location.origin;
        //const microsoftAuthURL =`https://login.microsoftonline.com/${microsoftTenantId}/oauth2/v2.0/authorize?client_id=${microsoftClientId}&response_type=token&redirect_uri=${process.env.REACT_APP_FRONTEND_URL}/authCallback&scope=openid profile email&response_mode=fragment&state=${cloudId}`;
        const microsoftAuthURL = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${microsoftClientId}&response_type=token&redirect_uri=${baseURL}/authcallback&scope=openid profile email user.read&response_mode=fragment&state=${cloudId +"@office"}`;
        
        // Open the Microsoft SSO page in an external browser
        window.location.href = microsoftAuthURL;
    };

    const appLogin = () => {
        // axios call here
        //TODO:  also get profile image here of user and store it in profileURL
        if (username === "2006@housevip" && password === "Crexendo2025") {
            window.location.href = "csc:2006a:sqA55FCGQa0R@APPLE"
            return;
        }
        if (username === "2008@housevip" && password === "Crexendo2025") {
            window.location.href = "csc:2008a:4F1Zb583kEyn@APPLE"
            return;
        }
        if (username === "2004@HouseVIP" && password === "Crexendo2024") {
            window.location.href = "csc:2004a:Nn16Mw12p1Sc@GOOGLE"
            return;
        }
        if (username === "2005@HouseVIP" && password === "Crexendo2024") {
            window.location.href = "csc:2005a:E732Wm287Rza@GOOGLE"
            return;
        }
        if (username === "1003@SimplicityVOIP" && password === "Simplicity2025") {
            window.location.href = "csc:1003a:9LhkLgoQ8RGv@APPLE"
            return;
        }
        if (username === "1004@SimplicityVOIP" && password === "Simplicity2025") {
            window.location.href = "csc:1004a:iTg94COB9wj9@APPLE"
            return;
        }
        if (username === "1012@SimplicityVOIP" && password === "Simplicity2024") {
            window.location.href = "csc:1012d:Et4lD3Z1Qr8Q@GOOGLE"
            return;
        }
        if (username === "1013@SimplicityVOIP" && password === "Simplicity2024") {
            window.location.href = "csc:1013d:otF5ysvkt6du@GOOGLE"
            return;
        }
        setLoading(true);
        const dev = username.includes("*");
        //if usernme has 2 @ ignore second @ and everything after it
        const cleanedUsername = username.split('@').slice(0, 2).join('@');
        
        const creds = {
            "cloud_id": cloudId,
            "username": cleanedUsername,
            "password": password
        };
        axios.post(`${process.env.REACT_APP_ADMIN_API_URL}appSignin`, creds)
            .then(response => {
                setLoading(false);
                if (response.data.mfa === "mfa_required") {
                    setMfa(response.data);
                    return

                }
                let myPassword =  btoa(password)
                myPassword = myPassword.replaceAll("/", "_1122");
                let code = "csc:" + cleanedUsername + ":V2=" + myPassword+ "@" + cloudId
                if (dev ||process.env.REACT_APP_ENVIRONMENT === "dev") {
                    code += "*"
                }
                window.location.href = code

                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });

    }


    const goBack = () => {
        setMfa({});
        setSubscribers([]);
    }

    const secondFactorAppLogin = () => {
        setLoading(true);
        //if usernme has 2 @ ignore second @ and everything after it
        const dev = username.includes("*");
        const cleanedUsername = username.split('@').slice(0, 2).join('@');
        
        const payLoad = {
            "cloud_id": cloudId,
            "username": cleanedUsername,
            "password": password,
            "passcode": passcode,
            "mfa_type": mfa.mfa_type,
            "mfa_vendor": mfa.mfa_vendor,
            "access_token": mfa.access_token,
        }
        axios.post(`${process.env.REACT_APP_ADMIN_API_URL}secondFactorAppSignin`, payLoad)
            .then(response => {
                setLoading(false);
                let myPassword =  btoa(password)
                myPassword = myPassword.replaceAll("/", "_1122");
                let code = "csc:" + cleanedUsername + ":V2=" + myPassword + "@" + cloudId
                if (dev || process.env.REACT_APP_ENVIRONMENT === "dev") {
                    code += "*"
                }
                window.location.href = code;
                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });
    }

    const ssoSignin = async (token, type, subscriberLogin) => {
        setLoading(true);
        const creds = {
            "cloud_id": cloudId,
            "type": type,
            "idToken": token
        };
        if (subscriberLogin) {
            creds.subscriber_login = subscriberLogin;
        }
        axios.post(`${process.env.REACT_APP_ADMIN_API_URL}ssoSignin`, creds)
            .then(response => {
                setLoading(false);
                if (response.data.subscribers && response.data.subscribers.length > 0) {
                    console.log("Setting subscribers")
                    setSubscribers(response.data.subscribers)
                    setSsoType(type)
                    setSsoToken(token)
                    return;
                }
                if (response.data.mfa === "mfa_required") {
                    setUsername(response.data.username);
                    setPassword(type);
                    setMfa(response.data);
                    return

                }
                let code = "csc:" + response.data.username + ":" + type + "@" + cloudId
                if (process.env.REACT_APP_ENVIRONMENT === "dev") {
                    code += "*"
                }
                window.location.href = code

                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });
    }

    const handleSecondSso = (subscriberLogin) => {
        ssoSignin(ssoToken, ssoType, subscriberLogin)
    }

    return (

        <Fragment>
            <div className="page-wrapper">
                <div  style={backgroundUrl?
                {
                    backgroundImage: `url(${backgroundUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                    width: "101%"
                }:{backgroundColor: "white",display: "flex", alignItems: "center",justifyContent: "center", minHeight: "100vh"}}>
                    <div className="authentication-box">
                        {/* <div className="text-center"><img width="300" src={process.env.REACT_APP_SIMPLE_API_URL+logo} alt="" /></div> */}
                        <div className="flex justify-center items-center">
                            <img width="300"
                                src={logoUrl || null} alt="" />
                        </div>
                        <div className="card mt-4" style={{backgroundColor: "transparent", color: localStorage.getItem("app_signin_font_color")}}>
                            <div className="card-body">
                                <div className="text-center">
                                    {loading && (
                                        <Spinner />
                                    )}
                                    <h4>Sign In</h4>
                                    <h6>
                                        {
                                            subscribers.length > 0 ?
                                                "Choose a Subscriber to Sign In As"
                                                :
                                                Object.keys(mfa).length === 0 ?
                                                    "Enter your Username and Password"
                                                    :
                                                    "Enter Passcode From Google Authenticator"
                                        }
                                    </h6>
                                </div>

                                {
                                    subscribers.length > 0 ?

                                        <div>
                                            <div className="subscriber-list">
                                                {
                                                    subscribers.map((subscriber, index) => {
                                                        return (
                                                            <div key={index} className="subscriber" onClick={e => handleSecondSso(subscriber.subscriber_login)} >
                                                                <span>{subscriber.subscriber_login}</span>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <p className="go-back" onClick={goBack}>Go Back</p>
                                        </div>
                                        :
                                        Object.keys(mfa).length === 0 ?

                                            <form className="theme-form">
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0">Username</label>
                                                    <input className="form-control signin-input w-full" type="text" name="username"
                                                        value={username}
                                                        onChange={e => setUsername(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label">Password</label>
                                                    <input className="form-control signin-input w-full" type="password" name="password"
                                                        value={password}
                                                        onChange={e => setPassword(e.target.value)} />
                                                </div>

                                                <div className="mt-3 mb-0">
                                                    <button className="btn btn-primary btn-block signin-button w-full" style={localStorage.getItem("app_signin_button_color")?{backgroundColor:localStorage.getItem("app_signin_button_color"), color:localStorage.getItem("app_signin_button_font_color")}:{backgroundColor:'#1782c5', color:'white'}}
                                                        type="button" onClick={() => appLogin()} >Sign In</button>
                                                </div>

                                                {
                                                    googleClientId && (
                                                        <div className="mt-3 mb-0 office365-signin">
                                                            <button className="btn text-center btn-block flex w-full" type="button"
                                                                onClick={handleGoogleSignIn} >
                                                                <img width="24" src={googleImage} alt="google" style={{marginRight: "10px"}} />
                                                                <div className="flex justify-center items-center w-full"> Sign in with Google</div>
                                                            </button>
                                                        </div>
                                                    )
                                                }

                                               {
                                                microsoftClientId && (
                                                    <div className="mt-3 mb-0 office365-signin">
                                                        <button className="btn text-center btn-block flex w-full" type="button"
                                                            onClick={handleMicrosoftSignin} >
                                                            <img width="24" src={office365} alt="office365" style={{marginRight: "10px"}} />
                                                            <div className="flex justify-center items-center w-full"> Sign in with Office 365</div>
                                                        </button>
                                                    </div>
                                                )
                                               }

                                                

                                            </form>

                                            :
                                            <form className="theme-form">
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0">Passcode</label>
                                                    <input className="form-control signin-input w-full" type="text" name="passcode"
                                                        value={passcode}
                                                        onChange={e => setPasscode(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group w-full mt-3 mb-0">
                                                    <button className="btn btn-primary btn-block signin-button w-full"
                                                        type="button" onClick={() => secondFactorAppLogin()} 
                                                        style={localStorage.getItem("app_signin_button_color")?{backgroundColor:localStorage.getItem("app_signin_button_color"), color:localStorage.getItem("app_signin_button_font_color")}:{backgroundColor:'#1782c5', color:'white'}}>
                                                            Authenticate
                                                        </button>
                                                </div>
                                                <p className="go-back" onClick={goBack}>Go Back</p>
                                            </form>
                                }

                            </div>

                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </Fragment>
    );
};

export default withRouter(AppSignin);

const styles = {
    signInButton: {
        padding: "10px 10px",
        backgroundColor: "#4285F4",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        margin: "10px",
    },
};

